import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HOW_THE_WORK } from "../../data/content";
import { Reveal } from "../MaskedLine";

export default function HowTheWork() {
  return (
    <section data-testid="how-the-work-section" className="ground-ink text-[color:var(--paper)] sec-pad">
      <div className="wrap">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
          <div>
            <p className="stamp on-ink mb-4" style={{ color: "var(--paper)", fontSize: 12 }}>How the work happens</p>
            <h2 className="h-section" style={{ fontSize: "clamp(28px, 3.4vw, 46px)", lineHeight: 1.08 }}>
              Research → Diagnose → <span className="claim">Practise</span> → Measure.
            </h2>
          </div>
          <p className="font-body-serif measure-narrow" style={{ fontSize: 17, color: "rgba(239,231,214,0.75)" }}>
            The operating model behind every engagement. 70% practice, 30% framework.
          </p>
        </div>

        <div className="border-t-[1.5px] border-[color:var(--paper)] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {HOW_THE_WORK.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05}>
              <div
                data-testid={`how-step-${i}`}
                className={`p-8 md:p-10 h-full border-b-[1.5px] border-[color:var(--paper)] lg:border-b-0 ${i > 0 ? "md:border-l-[1.5px] md:border-[color:var(--paper)]" : ""}`}
              >
                <span className="stamp on-ink" style={{ color: "var(--pink)", fontSize: 12 }}>Step {s.n}</span>
                <h3 className="font-hook mt-6" style={{ fontSize: "clamp(28px, 2.4vw, 36px)", lineHeight: 1, letterSpacing: "-0.015em", color: "var(--paper)" }}>
                  {s.title}
                </h3>
                <p className="font-body-serif mt-5" style={{ fontSize: 16, lineHeight: 1.6, color: "rgba(239,231,214,0.82)" }}>
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex justify-end">
          <Link to="/how-we-design" className="arrow-link on-ink" data-testid="how-the-work-method-link">
            How we design — SAM, LTEM, Phillips <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
